import { AnyWidgetDef, ComingSoonWidgetDef } from '@recruitee/dashboard-types';

export const isComingSoonWidgetDef = (widgetDef: AnyWidgetDef): widgetDef is ComingSoonWidgetDef =>
  (<ComingSoonWidgetDef>widgetDef).comingSoon === true;
